import { createAction, props } from '@ngrx/store';
import { UpdateActivityState } from '../../models/update-activity-state';

export const cancelActivity = createAction(
    '[Cancel activity]',
    props<{cancelActivity: UpdateActivityState}>()
);

export const cancelActivitySuccess = createAction(
    '[Cancel activity] success',
);

export const validateActivity = createAction(
    '[Validate activity]',
    props<{validateActivity: UpdateActivityState}>()
);

export const validateActivitySuccess = createAction(
    '[Validate activity] success',
);

export const removeTask = createAction(
    '[Remove task]',
    props<{idTask: number}>()
);

export const removeTaskSuccess = createAction(
    '[Remove task] success',
);

export const validateTask = createAction(
    '[Validate task]',
    props<{idTask: number}>()
);

export const validateTaskSuccess = createAction(
    '[Validate task] success'
);

export const removeService = createAction(
    '[Remove service]',
    props<{idService: number}>()
);

export const removeServiceSuccess = createAction(
    '[Remove service] success'
);

export const validateService = createAction(
    '[Validate service]',
    props<{idService: number}>()
);

export const validateServiceSuccess = createAction(
    '[Validate service] success'
);

export const resetUpdateSchedule = createAction(
    '[Reset update]'
);
